'use strict';

export function storeProxy(store) {
    function setItem(...args) {
        return store.setItem(...args);
    }

    function getItem(...args) {
        return store.getItem(...args);
    }

    return Object.freeze({
        setItem,
        getItem
    });
}

export const sessionStorage = storeProxy(window.localStorage);



// WEBPACK FOOTER //
// ./src/api/store.js